import React from 'react';
import { useHistory } from 'react-router';
import { BullsEyeIcon } from 'pages/wholeme/icons/Icons';
import WholeMeProfileSection from '../wholeMeProfileSection/WholeMeProfileSection';

const WholeMeProfileGoals = ({ editable, profile }) => {
  const history = useHistory();

  const goToGoals = () => {
    const path = editable ? '/tabs/goals' : `/profile/goals/${profile.id}`;
    history.push(path);
  };

  if (!editable && !(profile?.goals?.[0]?.count ?? 0)) {
    return null;
  }

  return (
    <WholeMeProfileSection
      title="Goals"
      editable={editable}
      titleIcon={BullsEyeIcon({ transform: 'scaleX(-1)' })}
      onClickOverride={goToGoals}
    />
  );
};

export default WholeMeProfileGoals;
